
import store from "@/store";
import JsEncrypt from 'jsencrypt';
import { isMobileDevice } from './common'

async function getCommonUrl() {
  const userInfo = await store.dispatch("getVisitorInfo");
  const isEnglish = window.location.hostname.endsWith('.com') || window.location.pathname.startsWith('/en');
  const lang = isEnglish ? 'en' : 'cn';
  let account = '';
  let accountParams = '';
  let registerType = 'visitor';
  let registerLinkId = "2048761374962688001";
  if (isEnglish || userInfo.country_id != 256) {
    account = onEncryption(userInfo.email);  
    accountParams = `email=${account}`;
    // registerType = 'audience';
    registerLinkId = "2048761552150568962";
  } else {
    account = onEncryption(userInfo.mobile);
    accountParams = `phone=${account}`;
  }
  let domain = "https://ezt3.eastfair.com/pc"
  if (isMobileDevice()) {
    domain = "https://ezt3.eastfair.com";
  }

  const url = `${domain}/#/sialAudTransition?exhibitionId=1970834453140537345&registerType=${registerType}&languageType=${lang}&registrationSource=registration&tenantId=244043&registerLinkId=${registerLinkId}&isOpenAdapt=yes&${accountParams}`;
  // console.log('------url', url);
  
  
  return {
    url: url,
    accountParams: accountParams
  }
}

export async function toPreReg() {
  const {url} = await getCommonUrl()
  console.log('---toPreReg', url);
  
  await store.dispatch("user/logout");
  window.location.href=url;
}

export async function toInvite() { 
  const {url} = await getCommonUrl()
  console.log('---toInvite', url);

  toJump(`${url}&r=y`)
}

export async function toConfirmation() { 
  const {url} = await getCommonUrl()
  console.log('---toConfirmation', url);
  window.open(url)
  // toJump(url)
}

function toJump(url) {
  // window.open(url);
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.rel = 'noopener noreferrer';
  
  link.click();
}

function onEncryption(data) {
  const encryptor = new JsEncrypt();
  const publicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEArUOOPtVTpVOMlMqg9cJUpbuSlZqj2JNdCmg/OjfmVHZTnqjOQj58SzU/18YkPjNvfkghp4Fp1hwhIZWlYkrwHdDewcp9Yeq+TA/+Q1Gp36J2Ohc6Dz1ZwFyvOkkS+0Wq9cii1ttorulAeLz1obrBcMvCi4foUvzfa05MxmJ9/xniS1VPBu+MLqhW7m+c/MExw6Cr1J/6Z+MJ6IVWi+I8BMA0LfENs1/i4+mNmfnJV9khPKMIH7KJj/T1xAG2k5X+wFFH3+ADL36t/B6XL1Sspnc8wHSgP4lXCKBoXgDUAoQb61NXl06Jgf8U5TRcfU0LwH/r1gZTetlLANUFmkeI/wIDAQAB";
  encryptor.setPublicKey(publicKey);
  return encryptor.encrypt(data)
}